import { getMyPermissions } from "../Services/auth";

export const havePermission = permissionToCheck => {
	const mypermissions = getMyPermissions();

	return mypermissions.includes(permissionToCheck);
};

export const printLabel = (flag, label) => {
	if (flag === false && flag !== undefined) return label;
	else return `Load ${label}`;
};
